import { render, staticRenderFns } from "./xiaoyang.vue?vue&type=template&id=cf28ef38&scoped=true"
import script from "./xiaoyang.vue?vue&type=script&lang=js"
export * from "./xiaoyang.vue?vue&type=script&lang=js"
import style0 from "./xiaoyang.vue?vue&type=style&index=0&id=cf28ef38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf28ef38",
  null
  
)

export default component.exports